export default {
      id: "chevron-up-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.HITByrwA.svg#chevron-up-usage",
      toString: function () {
        return this.url;
      }
    }